<template>
  <div id="top" class="top-wrapper">
    <!-- 92以下隐藏 由hidden-sm-and-down控制 -->
    <div class="pc-top-wrapper hidden-sm-and-down">
      <div class="top-content share-content-1200">
        <router-link tag="div" to="/index" class="logo-box">
          <img src="../../../static/images/newLogo.png" alt="ijobwind和风">
        </router-link>
        <ul class="list-box">
          <li v-for="(item,index) in navItems" :key="index">
            <router-link tag="a" :to="item.path" :class="routeName == item.name?'active':''">{{item.txt}}</router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- 992及其以上隐藏 由hidden-md-and-up控制 -->
    <div class="mTop-wrapper hidden-md-and-up" :class="$route.name == 'recruitDetail'?'mTop-RecruitDetail':'' ">
      <router-link tag="div" to="/index" class="logo-box">
        <!-- <img src="../../../static/images/newLogo.png" alt="ijobwind和风"> -->
      </router-link>
      <router-link tag="p" to="/form">
        <span>我要应聘</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data () {
    return {
      routeName: "",
      navItems: [
        {
          path: "/index",
          name: "index",
          txt: "首页"
        },
        {
          path: "/advantage",
          name: "advantage",
          txt: "和风优势"
        },
        {
          path: "/policyIndex?tab=0",
          name: "policyDetail",
          txt: "赴日政策"
        },
        {
          path: "/recruitIndex",
          name: "recruitDetail",
          txt: "招聘岗位"
        }
        // {
        //   path:'/form',
        //   name:'form',
        //   txt:'我要办理'
        // }
      ]
    };
  },
  methods: {},
  watch: {
    $route (to, form) {
      // 监听路由变化 给对应的子路由加上active状态
      this.routeName = to.name;
    }
  }
};
</script>

<style scoped lang="less">
.pc-top-wrapper {
  position: fixed;
  width: 100%;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 0 5px #bfbfbf;
  -webkit-box-shadow: 0 0 5px #bfbfbf;
  .top-content {
    position: relative;
    .logo-box {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      cursor: pointer;
      img {
        margin-top: 0.18rem;
        width: 1.82rem;
      }
    }
    .list-box {
      font-size: 0;
      text-align: right;
      li {
        margin-left: 1rem;
        display: inline-block;
        a {
          padding: 0.35rem 0;
          display: block;
          color: #000000;
          font-size: 0.18rem;
          font-weight: bold;
          &.active,
          &:hover,
          &.router-link-active {
            color: #0f8ffd;
          }
        }
      }
    }
  }
}

// 移动端
.mTop-wrapper {
  position: relative;
  padding: 0.09rem 0.25rem 0.1rem;
  background-color: #ffffff;
  border-bottom: 1px solid #eeeeee;
  .logo-box {
    width: 1.33rem;
    height: 0.42rem;
    background: url('../../../static/images/newLogo.png') no-repeat center;
    background-size: cover;
    // img {
    //   width: 1.33rem;
    // }
  }
  p {
    position: absolute;
    top: 50%;
    right: 0.25rem;
    display: inline-block;
    padding: 0.07rem 0.15rem;
    font-size: 0.14rem;
    color: #ffffff;
    background-color: #0f8ffd;
    border-radius: 0.3rem;
    transform: translateY(-50%);
  }

  // 招聘详情 样式不一样
  &.mTop-RecruitDetail {
    margin-top: 0.1rem;
    background: transparent;
    border: none;
    .logo-box {
      background: url('../../../static/images/logo.png') no-repeat center;
      background-size: cover;
    }
  }
}

.share-content-1200 {
  width: 62.5%;
  margin: 0 auto;
}
@media screen and (max-width: 1680px) {
  .share-content-1200 {
    width: 72.5%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1440px) {
  .share-content-1200 {
    width: 82.5%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/top.vue